export const firebaseConfig = {
    apiKey: "AIzaSyAqpK6SEmqXsdBDzNBY9rBwOEArilriNvs",
    authDomain: "factsense-972dc.firebaseapp.com",
    projectId: "factsense-972dc",
    storageBucket: "factsense-972dc.firebasestorage.app",
    messagingSenderId: "555591036489",
    appId: "1:555591036489:web:d161c194e71786b6169998"
  };